var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divStyle"},[_c('iframe',{staticClass:"iframeStyle",attrs:{"src":_vm.url,"allowfullscreen":"","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }